// Author Shi Wen Long
// Date 2021-10-18 14:50:22

class SithMesSapHandleRecord {
constructor({
        id = null,
        path = '',
        module = '',
        flag = '',
        date = '',
        remark = ''}
= {}) {
    this.id = id;
    this.path = path;
    this.module = module;
    this.flag = flag;
    this.date = date;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesSapHandleRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.sap.sithMesSapHandleRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'path',
        label: 'label.sith.sap.sithMesSapHandleRecord.grid.path',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'module',
        label: 'label.sith.sap.sithMesSapHandleRecord.grid.module',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'flag',
        label: 'label.sith.sap.sithMesSapHandleRecord.grid.flag',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'date',
        label: 'label.sith.sap.sithMesSapHandleRecord.grid.date',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.sap.sithMesSapHandleRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    pathFilter : "",
    moduleFilter : "",
    flagFilter : "",
    dateRteFilter : "",
    dateLteFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'pathFilter',
        label: 'label.sith.sap.sithMesSapHandleRecord.filter.path',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'moduleFilter',
        label: 'label.sith.sap.sithMesSapHandleRecord.filter.module',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'flagFilter',
        label: 'label.sith.sap.sithMesSapHandleRecord.filter.flag',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dateRteFilter',
        label: 'label.sith.sap.sithMesSapHandleRecord.filter.dateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'dateLteFilter',
        label: 'label.sith.sap.sithMesSapHandleRecord.filter.dateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'path',
        label: 'label.sith.sap.sithMesSapHandleRecord.entity.path',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'module',
        label: 'label.sith.sap.sithMesSapHandleRecord.entity.module',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'flag',
        label: 'label.sith.sap.sithMesSapHandleRecord.entity.flag',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'date',
        label: 'label.sith.sap.sithMesSapHandleRecord.entity.date',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.sap.sithMesSapHandleRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesSapHandleRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
